export const tableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Ubicación',
                    type: 'custom-html',
                    key: 'org',
                    modifier: (item) => {
                        if(!item){
                            return "Matriz";
                        } else {
                            if (item.canton) {
                                return item.canton.name;
                            } else {
                                return item.city;
                            }
                            
                        }
                    }
                },
                // {
                //     title: 'Sector',
                //     type: 'custom-html',
                //     key: 'level_2',
                //     modifier: (item) => {
                //         return item.value;
                //     }
                // },
                {
                    title: 'Categoría',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Campo de Ensayo',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Grupo de Productos',
                    type: 'custom-html',
                    key: 'level_7_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Ensayo',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Técnica',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                // {
                //     title: 'Rango',
                //     type: 'text',
                //     key: 'level8',
                // },
                {
                    title: 'Método Interno',
                    type: 'custom-html',
                    key: 'level9',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Método Referencia',
                    type: 'custom-html',
                    key: 'level10',
                    modifier: (item) => {
                        return item;
                    }
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}